'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deserialize = require('./deserialize');

Object.defineProperty(exports, 'deserializeDocument', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deserialize).default;
  }
});

var _fetch = require('./fetch');

Object.keys(_fetch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fetch[key];
    }
  });
});

var _reducer = require('./reducer');

Object.keys(_reducer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _reducer[key];
    }
  });
});

var _action = require('./action');

Object.keys(_action).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _action[key];
    }
  });
});

var _utils = require('./utils');

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../~/prismic-utils/dist/index.js
// module id = 106
// module chunks = 0